import React from 'react';

import { ADMIN_TIME_OFF } from '@ApplicationWide/permissions/constants';
import { ADMIN } from '@ApplicationWide/routes/route-groups';
import { PlaneIcon } from '@Generic/icons';

const AdminTimeOffPage = React.lazy(() => import('../../../pages/Admin/TimeOff'));

export default {
  label: 'time-off.admin-page.title',
  group: ADMIN,
  to: '/administration/time-off',
  route: '/administration/time-off',
  component: AdminTimeOffPage,
  icon: <PlaneIcon />,
  requiredRoles: ['admin', 'super_admin'],
  adminVisibilityPermission: ADMIN_TIME_OFF,
  area: ADMIN_TIME_OFF,
  hasNavBar: true,
};
